import { render, staticRenderFns } from "./Opinions.vue?vue&type=template&id=48a69b2e&scoped=true&lang=pug"
import script from "./Opinions.vue?vue&type=script&lang=js"
export * from "./Opinions.vue?vue&type=script&lang=js"
import style0 from "./Opinions.vue?vue&type=style&index=0&id=48a69b2e&prod&scoped=true&lang=css"
import style1 from "./Opinions.vue?vue&type=style&index=1&id=48a69b2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a69b2e",
  null
  
)

export default component.exports